import React from "react";

const MenuIcon = ({
  className = "",
  fill = "none",
  height = 30,
  width = 30,
  stroke = "#556C84"
}: MenuIconProps) => (
  <svg width={width} height={height} viewBox="0 0 18 18" className={className}>
    <path
      fill={fill}
      stroke={stroke}
      strokeWidth={1}
      d="M.5 8.8c.2 0 .3.1.3.2s-.2.2-.3.2h17.1c-.2 0-.3-.1-.3-.2s.1-.2.3-.2H.5zm0-6.6c.2 0 .3.1.3.2s-.2.4-.3.4h17.1c-.2 0-.3-.1-.3-.2s.1-.2.3-.2H.5zm0 13c.2 0 .3.1.3.2s-.1.2-.3.2h17.1c-.2 0-.3-.1-.3-.2s.1-.2.3-.2H.5z"
    />
  </svg>
);

export default MenuIcon;

interface MenuIconProps {
  className?: string;
  fill?: string;
  height?: number;
  stroke?: string;
  width?: number;
}
